enum PublicApiService {
    Common = 'common',
    Form = 'form',
    Table = 'table'
}

export default PublicApiService;